<template>
    <div style='height: 98%'>
        <div class='crumbs mcrumb-self'>
            <el-breadcrumb separator='-'>
                <el-breadcrumb-item>
                    <i class='el-icon-setting'></i><span>系统设置</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item><span>邮箱服务器管理</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='padding: 15px; height: 92%'>
            <div style='padding-bottom: 10px'>
                <el-row type='flex'>
                    <el-col :span='8'>
                        <el-button type='primary' style='width: 80px' @click='emailConfigClickFun(`0`,``)'>新增
                        </el-button>
                        <el-button plain style='width: 80px' @click='deleteEmailConfigsClickFun()'>删除</el-button>
                    </el-col>
                </el-row>
            </div>
            <div style='height: 94%'>
                <el-table :data='emailConfigTableData' border stripe height='90%' class='table' ref='emailConfigTable'
                          highlight-current-row @row-click='clickRowByChecked'>
                    <el-table-column type='selection' width='55' align='center'></el-table-column>
                    <el-table-column prop='id' v-if='showColumn'></el-table-column>
                    <el-table-column prop='host' label='服务器' sortable></el-table-column>
                    <el-table-column prop='pwd' label='授权密码' sortable></el-table-column>
                    <el-table-column prop='port' label='端口' sortable></el-table-column>
                    <el-table-column prop='address' label='邮箱地址' sortable></el-table-column>
                    <el-table-column prop='hostType' label='服务器类型' sortable></el-table-column>
                    <el-table-column prop='emailSSL' label='是否启用SSL' sortable>
                        <template slot-scope='scope'>
                            <span style='margin-left: 10px'>{{ ['否', '是'][scope.row.emailSSL] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop='companyTaxNumber' label='公司税号' sortable='true'></el-table-column>
                    <el-table-column prop='companyName' label='公司名称' sortable='true'></el-table-column>
                    <el-table-column prop='operate' label='操作' width='120' align='center' fixed='right'>
                        <template slot-scope='scoped'>
                            <el-button size='small' type='text' @click="emailConfigClickFun('1', scoped.row)">查看
                            </el-button>
                            <el-button size='small' type='text' @click="emailConfigClickFun('2', scoped.row)">编辑
                            </el-button>
                            <el-button size='small' type='text' @click='deleteEmailConfigClickFun(scoped.row)'>删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class='pagination'>
                    <el-pagination
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page='pwm.page'
                        :page-size='pwm.limit'
                        :page-sizes='pwm.limits'
                        layout='total, sizes, prev, pager, next, jumper'
                        :total='pwm.count'>
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title='emailConfigTitle' :visible.sync='emailConfigDialogVisible' class='dialog' width='55%'
                   :close-on-click-modal='false'>
            <div class='custom-dialog'>
                <el-form :model='emailConfigForm' ref='emailConfigForm' :rules='emailConfigFormRule'>
                    <el-input v-if='false' v-model='emailConfigForm.id'></el-input>
                    <div style='padding-bottom: 15px'>
                        <div style='display: flex;padding-top: 15px'>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color:red;'>*</span>服务器</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='host'>
                                        <el-input v-model='emailConfigForm.host'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color:red;'>*</span>授权密码</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='host'>
                                        <el-input v-model='emailConfigForm.pwd'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex; padding-top: 15px'>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red'>*</span>端口</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='port'>
                                        <el-input v-model='emailConfigForm.port'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color:red;'>*</span>邮箱地址</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='address'>
                                        <el-input v-model='emailConfigForm.address'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex;padding-top: 15px'>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red'>*</span>服务器类型</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='hostType'>
                                        <el-input v-model='emailConfigForm.hostType'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color:red;'>*</span>是否启用SSL</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='emailSSL'>
                                        <el-select v-model='emailConfigForm.emailSSL' placeholder='请选择'
                                                   style='width: 100%'>
                                            <el-option v-for='item in sslOptions' :key='item.value' :label='item.label'
                                                       :value='item.value'>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex;padding-top: 15px'>
                            <div class='ar-form-item' style='width: 50%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red'>*</span>所属公司</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='companyTaxNumber'>
                                        <el-select v-model='emailConfigForm.companyTaxNumber' placeholder='请选择'
                                                   style='width: 100%'>
                                            <el-option v-for='item in allCompanyList' :key='item.taxNumber'
                                                       :label='item.name'
                                                       :value='item.taxNumber'>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='saveEmailConfig(`emailConfigForm`)' style='width: 80px'
                           v-if='showSaveBtn'>保存</el-button>
                <el-button @click='emailConfigDialogVisible = false' style='width: 80px'>返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchGet, fetchPost } from '../../../../https';

export default {
    data() {
        return {
            showSaveBtn: false,
            emailConfigTitle: '',
            emailConfigDialogVisible: false,
            pwm: {
                count: 0,
                limit: 0,
                page: 1,
                limits: [10, 20, 50, 100]
            },
            emailConfigForm: {
                id: '',
                host: '',
                pwd: '',
                port: '',
                address: '',
                hostType: '',
                emailSSL: '',
                companyTaxNumber: ''
            },
            emailConfigFormRule: {
                host: [
                    { required: true, message: '请输入服务器信息', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入授权密码', trigger: 'blur' }
                ],
                port: [
                    { required: true, message: '请输入端口号', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' }
                ],
                hostType: [
                    { required: true, message: '请输入邮箱服务器类型', trigger: 'blur' }
                ],
                emailSSL: [
                    { required: true, message: '请选择是否启用SSL', trigger: 'blur' }
                ],
                companyTaxNumber: [
                    { required: true, message: '请选择所属公司', trigger: 'blur' }
                ]
            },
            showColumn: false,
            emailConfigTableData: [],
            currEmailConfigData: '',
            sslOptions: [
                {
                    value: '0',
                    label: '否'
                },
                {
                    value: '1',
                    label: '是'
                }
            ],
            currGroupData: '',
            allCompanyList: '',
            emailConfigOpUrl: ''
        };
    },
    created: function() {
        this.getCurrentGroupData().then(val => {
            this.getCompanyDataByCurrGroupId(this.currGroupData.id);
            this.getEmailConfigByCurrGroupId();
        });
    },
    methods: {
        handleSizeChange(val) {
            this.pwm.limit = val;
            this.getEmailConfigByCurrGroupId();
        },
        handleCurrentChange(val) {
            this.pwm.page = val;
            this.getEmailConfigByCurrGroupId();
        },
        clickRowByChecked(row) {
            this.$refs.emailConfigTable.toggleRowSelection(row);
        },
        deleteEmailConfig(ids) {
            fetchPost('/sys/admin/deleteEmailConfigs', ids).then(res => {
                if (res.data.success) {
                    this.$message.success('删除邮箱配置信息成功');
                    this.getEmailConfigByCurrGroupId();
                } else {
                    this.$message.error('删除邮箱配置信息失败:' + res.data.message);
                }
            }, error => {
                this.$message.error('删除邮箱配置信息失败：' + error);
            });
        },
        emailConfigClickFun(opType, row) {
            Object.keys(this.emailConfigForm).map(key => (this.emailConfigForm[key] = ''));
            this.$nextTick(() => {
                if (this.$refs.emailConfigForm) {
                    this.$refs.emailConfigForm.clearValidate();
                }
            });
            if (opType === '0') {
                this.emailConfigTitle = '新增邮箱服务器配置';
                this.showSaveBtn = true;
                this.emailConfigOpUrl = '/sys/admin/addEmailConfig';
                this.emailConfigDialogVisible = true;
            } else if (opType === '1') {
                this.emailConfigTitle = '查看邮箱服务器配置';
                this.showSaveBtn = false;
                this.emailConfigDialogVisible = true;
                this.getEmailConfigDataById(row);
            } else if (opType === '2') {
                this.emailConfigTitle = '编辑邮箱服务器配置';
                this.showSaveBtn = true;
                this.emailConfigOpUrl = '/sys/admin/updateEmailConfig';
                this.emailConfigDialogVisible = true;
                this.getEmailConfigDataById(row);
            }
        },
        saveEmailConfig(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false;
                }
                fetchPost(this.emailConfigOpUrl, this.emailConfigForm).then(res => {
                    if (res.data.success) {
                        this.$message.success('保存邮箱配置信息成功！');
                        this.emailConfigDialogVisible = false;
                        this.getEmailConfigByCurrGroupId();
                    } else {
                        this.$message.error('保存邮箱配置信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('保存邮箱配置信息失败：' + error);
                });
            });
        },
        // 获取邮箱服务器配置信息
        getEmailConfigDataById(row) {
            fetchPost('sys/admin/getEmailConfigById', row.id).then(res => {
                if (res.data.success) {
                    this.emailConfigForm = res.data.data;
                } else {
                    this.$message.error('加载邮箱服务器信息失败:' + res.data.message);
                }
            }, error => {
                this.$message.error('加载邮箱服务器信息失败:' + error);
            });
        },
        // 多选删除邮箱服务器配置信息
        deleteEmailConfigsClickFun() {
            let ids = [];
            let checkRows = this.$refs.emailConfigTable.selection;
            if (!checkRows || checkRows.length === 0) {
                this.$message.warning('请选择需要删除的邮箱配置信息');
                return;
            }
            checkRows.forEach(row => {
                ids.push(row.id);
            });
            this.$confirm('是否删除选中邮箱服务器配置信息', '提示', {
                type: 'warning'
            }).then(() => {
                this.deleteEmailConfig(ids.join(','));
            });
        },
        // 删除邮箱服务器配置信息
        deleteEmailConfigClickFun(row) {
            this.$confirm('是否删除选中邮箱配置信息？', '提示', {
                type: 'warning'
            }).then(() => {
                this.deleteEmailConfig(row.id);
            });
        },
        async getCurrentGroupData() { //  当前集团信息 : 同步执行
            await fetchPost('/sys/admin/getCurrentCompanyGroup', '').then(res => {
                if (res.data.success) {
                    this.currGroupData = res.data.obj;
                } else {
                    this.$message.error('获取当前集团信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前集团信息错误：' + error);
            });
        },
        async getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
            await fetchPost('/sys/main/getUserBeLongsCompanyList', groupId).then(res => {
                if (res.data.success) {
                    this.allCompanyList = res.data.obj;
                    console.log(this.allCompanyList);
                } else {
                    res.data.data;
                    this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前集团下所有实体信息失败：' + error);
            });
        },
        getEmailConfigByCurrGroupId() {
            this.pwm.search = { 'groupId': this.currGroupData.id };
            fetchPost('/sys/main/getEmailConfigByCurrGroupId', this.pwm).then(res => {
                this.emailConfigTableData = res.data.data;
                this.pwm.count = res.data.count;
            }, error => {
                this.$message.error('获取邮箱配置信息失败：' + error);
            });
        },
        formatEmailSSL(row, column) {
            return row.emailSSL === '1' ? '是' : '否';
        }
    }

};
</script>

<style scoped>

</style>
